<template>
  <Card
    :card-class-names="cardClassNames"
    :has-body-padding="false"
    header-class-names="tw-flex tw-justify-items-start tw-items-center tw-px-2 tw-py-4"
    :is-relative-full-height="isRelativeFullHeight"
  >
    <template #header>
      <h2 class="section-title heading-color">
        Right Now
      </h2>
      <EstimatedBadge
        additional-class-names="tw-ml-2"
        size="base"
      />
    </template>
    <template #body>
      <CurrentConditions
        class="tw-mb-2 tw-p-2.5"
        :current-details-class-names="currentDetailsClassNames"
        :forecast-current="forecastCurrent"
      />
      <SnowLocationFooter
        :class="snowLocationFooterClass"
        :location="location"
        view-type="currentWeather"
      />
    </template>
  </Card>
</template>

<script>
export default {
  name: 'CurrentWeatherCard',

  props: {
    cardClassNames: {
      type: String,
      default: null,
    },
    isRelativeFullHeight: {
      type: Boolean,
      default: false,
    },
    isStretched: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      default: null,
    },
    narrowView: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    currentDetailsClassNames() {
      return this.narrowView ? 'md:tw-w-1/2' : undefined;
    },

    forecastCurrent() {
      return this.location.forecast_current;
    },

    snowLocationFooterClass() {
      return [
        'tw-px-2.5 tw-py-2.5',
        this.isStretched ? 'md:tw-pt-2.5 md:tw-pb-0.5 md:tw-mt-2.5' : null,
        'tw-border-t border-color',
      ];
    },
  },
};
</script>
